import { render, staticRenderFns } from "./IconMinus.vue?vue&type=template&id=fb7c9abe&scoped=true&"
import script from "./IconMinus.vue?vue&type=script&lang=js&"
export * from "./IconMinus.vue?vue&type=script&lang=js&"
import style0 from "./IconMinus.vue?vue&type=style&index=0&id=fb7c9abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7c9abe",
  null
  
)

export default component.exports